// @flow
import FaqWrapper from 'components/contact/FaqWrapper';
import { connect } from 'react-redux';
import { fetchThemes, fetchQuestions } from 'actions/faqActions';

import type { DispatchProps, StateProps } from 'components/contact/FaqWrapper';
import type { DispatchType, StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      themes: state.faqState.themes,
      questions: state.faqState.questions,
      ligue: state.settingsState.ligue,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchThemes: () => dispatch(fetchThemes()),
      fetchQuestions: () => dispatch(fetchQuestions())
    })
  )(FaqWrapper)
);
